import { AssistedImportRepository } from '@lib/api/repository/assisted-import/assisted-import.repository';

import { Requester } from '../clients';

export default class AssistedImportAPI implements AssistedImportRepository {
  async createAssistedImportRequest(notes?: string, source?: string) {
    return (
      await Requester.post<import('@lib/types').AssistedImportRequest>(
        '/marketplace/inventory/assisted-import/requests',
        { body: { notes, source } },
      )
    ).data;
  }

  async listAdminAssistedImportRequests(
    filters?: import('@lib/types').AssistedImportFilters, signal?: AbortSignal,
  ) {
    return (
      await Requester.get<import('@lib/types').AssistedImportRequest[]>(
        '/marketplace/admin/assisted-import/requests',
        {signal,  params: filters ? { ...filters } : undefined },
      )
    ).data;
  }

  async updateAssistedImportRequestStatus(
    id: string,
    status: 'pending' | 'contacted' | 'completed' | 'cancelled',
    notes?: string,
  ) {
    return (
      await Requester.patch<import('@lib/types').AssistedImportRequest>(
        `/marketplace/admin/assisted-import/requests/${id}/status`,
        { body: { status, notes } },
      )
    ).data;
  }
}
